import { useMutation } from "@tanstack/react-query";

import { askFluffyJaws } from "@app/services/fluffyjaws";

export const useAskFluffyJaws = (options = {}) => {
  return useMutation({
    mutationFn: (
      { query, sessionId, autoInitialize, fluffyPackUuid },
      { signal },
    ) =>
      askFluffyJaws(
        { query, sessionId, autoInitialize, fluffyPackUuid },
        { signal },
      ),
    ...options,
  });
};
